import * as types from "./actionTypes";

export const modalData = data => {
  return {
    type: types.PANEL_SELECTION_MODAL_DATA,
    data
  };
};
export const closeModal = () => {
  return {
    type: types.PANEL_SELECTION_CLOSE_MODAL
  };
};
